import 'highcharts/modules/drilldown';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useEffect, useState } from 'react';

interface RevenueDataItem {
  Name: string;
  Value: number;
  Percentage: number | null;
  AndroidValue: number | null;
  iOSValue: number | null;
  Total: number;
}

interface MonthlyRevenueProps {
  data: {
    items: RevenueDataItem[];
    drilldown: RevenueDataItem[];
  };
}

export const MonthlyRevenue = ({ data }: MonthlyRevenueProps) => {
  const [options, setOptions] = useState<Highcharts.Options>({});

  useEffect(() => {
    if (!data?.items || !data?.drilldown) return;
    const colors = [
      '#FF2A00',
      '#008048',
      '#35B1E8',
      '#FFA51F',
      '#FEBEC8',
      '#98D8EF',
      '#008044',
      '#35B1E8',
    ];

    // Main Series Data (Monthly)
    const mainSeriesData = data.items.map((item, index) => ({
      name: item.Name,
      y: item.Value,
      drilldown: item.Value > 0 ? item.Name : null, // Only enable drilldown if value exists
      color: colors[index % colors.length], // Cycle through colors
    }));

    // Prepare Drilldown Data (Daily)
    const drilldownSeries: Highcharts.SeriesOptionsType[] = [];

    const monthWithValue = data.items.find((m) => m.Value > 0);
    if (monthWithValue) {
      const drillData = data.drilldown
        .filter((d) => d.Value > 0)
        .map((d) => [d.Name, d.Value]);

      drilldownSeries.push({
        id: monthWithValue.Name,
        name: `${monthWithValue.Name} Details`,
        type: 'column',
        data: drillData.length ? drillData : [['No Data', 0]],
      });
    }

    // Chart Options
    setOptions({
      chart: {
        type: 'column',
      },
      title: {
        text: 'Monthly Revenue',
        style: {
          fontSize: '13px',
        },
      },
      xAxis: {
        type: 'category',
        labels: {
          style: {
            fontSize: '11px',
          },
        },
      },
      yAxis: {
        title: {
          text: 'Total',
        },
        labels: {
          style: {
            fontSize: '11px',
          },
        },
      },

      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: false,
            format: '{point.y:.1f}',
          },
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<b>Amount: {point.y:.2f} KD</b><br/>',
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'Revenue',
          colorByPoint: true,
          type: 'column',
          data: mainSeriesData,
        } as any,
      ],
      ...(data?.drilldown?.length > 1 && {
        drilldown: {
          series: drilldownSeries,
        },
      }),
    });
  }, [data]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
